<div class="fwc-container sae-review-body">
  <div class="fwc-row">
    <div class="fwc-col-12 review-intro">
      <h2>{{content.sectionHead}}</h2>
      <div>
        <span class="fwc-icon fwc-icon-lock-icon"> </span> {{content.sectionContent}}
      </div>
    </div>
  </div>
</div>

<div class="fwc-container sae-review-cards">
  <div class="fwc-row">
    <!-- for new-enrollment  -->
    @if (path === 'new-enrollment' ) {
      <div class="fwc-col-12 fwc-card-generic flat card-container">
        @if (!reviewContent?.isMyAccount) {
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-8">
              <h3>{{content.selectedCoverage.subheading}}</h3>
            </div>
            <div class="fwc-col-4 editButtonEnd">
              <button class="fwc-btn fwc-btn-secondary medium" (click)="edit('Select Coverage')">Edit</button>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-2 sm-6 fwc-flex-column">
              <strong>Status</strong>
              <div> Enrolling</div>
            </div>
            <div class="fwc-col-2 sm-6 fwc-flex-column">
              <strong>Term</strong>
              <div>{{enrollmentData?.termLabel}}</div>
            </div>
            <div class="fwc-col-6 fwc-flex-column">
              <strong>Coverage Dates</strong>
              <div>{{formatDate($safeNavigationMigration(enrollmentData?.effectiveDate))}} to
              {{formatDate($safeNavigationMigration(enrollmentData?.terminationDate))}}</div>
            </div>
          </div>
          <div class="fwc-row">
            <div class="fwc-col-12 fwc-divider">
            </div>
          </div>
        }
        <!-- for my-account  -->
        @if (reviewContent?.isMyAccount) {
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-8">
              <h4 class="btm-xxs">Coverage Dates</h4>
              @if (reviewContent?.isEdit) {
                <p>{{formatDate($safeNavigationMigration(reviewContent?.content?.selectCovDatesEdit))}}</p>
              }
              @if (reviewContent?.isAdd) {
                <p>{{formatDate($safeNavigationMigration(reviewContent?.content?.selectCovDatesAdd))}}</p>
              }
            </div>
            <div class="fwc-col-4 editButtonEnd">
              <button class="fwc-btn fwc-btn-secondary medium" (click)="updateDates()">Edit</button>
            </div>
          </div>
          <div class="fwc-row fwc-row-bm">
            <div class="fwc-col-6 fwc-flex-column">
              <strong class="btm-xxs">Coverage Dates</strong>
              <div> <strong class="right-xxs">From: </strong> {{formatDate($safeNavigationMigration(reviewContent?.startDate))}} <strong
            class="left-xs right-xxs">To:</strong> {{formatDate($safeNavigationMigration(reviewContent?.endDate))}} </div>
          </div>
        </div>
      }
      <!-- for new-enrollment  -->
      @if (!reviewContent?.isMyAccount) {
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-8">
            <h3>{{content.aboutYou.subheading}}</h3>
          </div>
          <div class="fwc-col-4 editButtonEnd">
            <button class="fwc-btn fwc-btn-secondary medium" (click)="edit('About You')">Edit</button>
          </div>
        </div>
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-2 sm-6 fwc-flex-column">
            <strong>Student ID#</strong>
            <div>{{enrollmentData?.studentId}}</div>
          </div>
          <div class="fwc-col-2 sm-6 fwc-flex-column">
            <strong>First Name</strong>
            <div>{{enrollmentData?.firstName}}</div>
          </div>
          <div class="fwc-col-2 sm-6 fwc-flex-column">
            <strong>Last Name</strong>
            <div>{{enrollmentData?.lastName}}</div>
          </div>
          <div class="fwc-col-1 sm-6 fwc-flex-column">
            <strong>Gender</strong>
            <div>{{enrollmentData?.genderCode}}</div>
          </div>
          <div class="fwc-col-2 sm-6 fwc-flex-column">
            <strong>Academic Level</strong>
            <div>{{enrollmentData?.academicLevel}}</div>
          </div>
          <div class="fwc-col-2 sm-6 fwc-flex-column">
            <strong>Date of Birth</strong>
            <div>{{enrollmentData?.dob}}</div>
          </div>
        </div>
        <div class="fwc-row fwc-row-bm">
          <div class="fwc-col-4 sm-6 fwc-flex-column">
            <strong>Email Address</strong>
            <div>{{enrollmentData?.email}}</div>
          </div>
          <div class="fwc-col-4sm-6  fwc-flex-column">
            <strong>Primary Phone</strong>
            <div>{{enrollmentData?.phone}}</div>
          </div>
        </div>
      }
      @if (dependents) {
        @for (dependent of dependents.dependent ; track dependent; let i = $index) {
          <div>
            <div class="fwc-row">
              <div class="fwc-col-12 fwc-divider">
              </div>
            </div>
            <div class="fwc-row fwc-row-bm">
              <div class="fwc-col-8">
                <h3>Dependent {{i+1}}</h3>
              </div>
              @if (!reviewContent?.isMyAccount) {
                <div class="fwc-col-4 editButtonEnd">
                  <button class="fwc-btn fwc-btn-secondary medium" (click)="edit('Dependent(s)')">Edit</button>
                </div>
              }
            </div>
            <div class="fwc-row fwc-row-bm">
              <div class="fwc-col-2 sm-6 fwc-flex-column">
                <strong>Type</strong>
                <div>{{dependent.type}}</div>
              </div>
              <div class="fwc-col-2 sm-6 fwc-flex-column">
                <strong>First Name</strong>
                <div>{{dependent.firstName}}</div>
              </div>
              <div class="fwc-col-2 sm-6 fwc-flex-column">
                <strong>Middle Initial</strong>
                <div>{{dependent.middleInitial}}</div>
              </div>
              <div class="fwc-col-2 sm-6 fwc-flex-column">
                <strong>Last Name</strong>
                <div>{{dependent.lastName}}</div>
              </div>
              <div class="fwc-col-1 sm-6 fwc-flex-column">
                <strong>Gender</strong>
                <div>{{dependent.gender}}</div>
              </div>
              <div class="fwc-col-2 sm-6 fwc-flex-column">
                <strong>Identify As</strong>
                <div>{{dependent.identityAs}}</div>
              </div>
              <div class="fwc-col-2 sm-6 fwc-flex-column">
                <strong>Date of Birth</strong>
                <div>{{dependent.DOB}}</div>
              </div>
            </div>
            <div class="fwc-row fwc-row-bm">
              <div class="fwc-col-4 sm-6 fwc-flex-column">
                <strong>Email Address</strong>
                <div>{{dependent.email}}</div>
              </div>
              <div class="fwc-col-4 sm-6 fwc-flex-column">
                <strong>Primary Phone</strong>
                <div>{{dependent.phone}}</div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  }

  <!-- for Waiver  -->
  @if (path === 'waiver' ) {
    <div class="fwc-col-12 fwc-card-generic flat card-container">
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-12 ">
          <fwc-alert type="info" area="inline">{{content.alert}}</fwc-alert>
        </div>
      </div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-8">
          <h3>{{content.waivingTerm.subheading}}</h3>
        </div>
        <div class="fwc-col-4 editButtonEnd">
          <button class="fwc-btn fwc-btn-secondary medium" (click)="editWaiver(1)">Edit</button>
        </div>
      </div>
      <div class="fwc-row fwc-row-bm">
        <div class="fwc-col-2 fwc-flex-column">
          <strong>Status</strong>
          <div> <span
          [ngClass]="waiverReview?.enrollment_status !== 'ENROLLED AUTO' ? 'fwc-badge info' : 'fwc-badge urgent' ">{{waiverReview?.enrollment_status}}</span>
        </div>
      </div>
      <div class="fwc-col-2 fwc-flex-column">
        <strong>Term</strong>
        <div>{{waiverReview?.term_label}}</div>
      </div>
      <div class="fwc-col-6 fwc-flex-column">
        <strong>Coverage</strong>
        @if (selectWavier?.paymentFrequency ==='once' ) {
          <div>{{waiverReview?.effective_date}} to
          {{waiverReview?.termination_date}}</div>
        }
        @if (selectWavier?.paymentFrequency !=='once' ) {
          <div>{{waiverReview?.effective_date }} to
          {{waiverReview?.termination_date}}</div>
        }
      </div>
    </div>
    <div class="fwc-row">
      <div class="fwc-col-12 fwc-divider">
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-8">
        <h3>{{content.aboutYou.subheading}}</h3>
      </div>
      <div class="fwc-col-4 editButtonEnd">
        <button class="fwc-btn fwc-btn-secondary medium" (click)="editWaiver(2)">Edit</button>
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-2 fwc-flex-column">
        <strong>First Name</strong>
        <div>{{waiverReview?.first_name}}</div>
      </div>
      <div class="fwc-col-2 fwc-flex-column">
        <strong>Last Name</strong>
        <div>{{waiverReview?.last_name}}</div>
      </div>
      <div class="fwc-col-2 fwc-flex-column">
        <strong>DOB</strong>
        <div>{{waiverReview?.dob}}</div>
      </div>
      <div class="fwc-col-2 fwc-flex-column">
        <strong>Phone</strong>
        <div>{{waiverReview?.phone}}</div>
      </div>
      <div class="fwc-col-4 fwc-flex-column">
        <strong>Email</strong>
        <div>{{waiverReview?.email}}</div>
      </div>
    </div>
    <div class="fwc-row">
      <div class="fwc-col-12 fwc-divider">
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-8">
        <h3>{{content.insuranceCarrierDetails.subheading}}</h3>
      </div>
      <div class="fwc-col-4 editButtonEnd">
        <button class="fwc-btn fwc-btn-secondary medium" (click)="editWaiver(3)">Edit</button>
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-2 fwc-flex-column">
        <strong>Status</strong>
        <div> <span class="fwc-badge success">{{waiverReview?.status}}</span></div>
      </div>
      <div class="fwc-col-4 fwc-flex-column">
        <strong>Carrier</strong>
        <div>{{waiverReview?.payer_name}}</div>
      </div>
      <div class="fwc-col-2 fwc-flex-column">
        <strong>Medical ID #</strong>
        <div>{{waiverReview?.medical_id_no}}</div>
      </div>
      <div class="fwc-col-4 fwc-flex-column">
        <strong>Insured Name</strong>
        <div>{{waiverReview?.primary_first_name}} {{waiverReview?.primary_last_name}}</div>
      </div>
    </div>
    <div class="fwc-row">
      <div class="fwc-col-12">
        {{contentInsurance.autoEnrollInfo}}
      </div>
    </div>
    <div class="fwc-row">
      <div class="fwc-col-12 fwc-divider">
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-12">
        <h3 class="btm-xxs">{{content.heading}}</h3>
        <p>{{content.content}}</p>
      </div>
    </div>
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-col-12 disclosure-container">
        <div class="fwc-checkbox">
          <input type="checkbox" name="disclosureCheckbox" id="disclosureCheckbox" value="true"
            [(ngModel)]="waiverAgreement" (keydown.enter)="waiverAgreement = !waiverAgreement" />
          <label for="disclosureCheckbox"><strong>{{content.aggrement}}</strong></label>
        </div>
      </div>
    </div>
  </div>
}
</div>
</div>

@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}